import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './TelegramPopup.css';
import $api from '../../http';
import { setDownloadURLs, setGuestAuth } from '../../store/actions'
import { useDispatch } from 'react-redux';

interface ApiResponse {
  status: 'OK' | 'BAD' | 'register code';
  bot_url?: string;
  telegram_code_token?: string;
  message?: string;
}

interface GuestLoginResponse {
  token: string;
  download_urls?: {
    google: string;
    apple: string;
  };
  qr_url?: string;
}

interface TelegramPopupProps {
  phone: string;
  onClose: () => void;
  siteDesign: {
    color_text: string;
    color_button: string;
    color_text_button: string;
    background_color1: string;
    background_color2: string;
    text_shadow: boolean;
    use_call_check: boolean;
    use_telegram_check: boolean;
    verification_always: boolean;
    capcha_check: boolean;
  };
}

const TelegramPopup: React.FC<TelegramPopupProps> = ({ phone, onClose, siteDesign }) => {
  const [code, setCode] = useState('');
  const [showError, setShowError] = useState(false);
  const [showTelegramButton, setShowTelegramButton] = useState(false);
  const [telegramBotUrl, setTelegramBotUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const codeInputRef = useRef<HTMLInputElement>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobileScreen = window.matchMedia('(max-width: 767px)').matches;

  useEffect(() => {
    console.log('TelegramPopup - capcha_check value:', siteDesign.capcha_check);
    const initializeComponent = async () => {
      setIsLoading(true);
      
      if (siteDesign.use_telegram_check) {
        await postTelegramCheck();
      }

      setIsLoading(false);
      codeInputRef.current?.focus();
    };

    initializeComponent();
  }, []);

  const postTelegramCheck = async () => {
    try {
      const response = await $api.post<ApiResponse>(`/customers/checkTelegram/?phone=+${phone}`);
      const data = response.data;
      
      if (data.status === 'register code' && data.bot_url) {
        setShowTelegramButton(true);
        setTelegramBotUrl(data.bot_url);
      } else {
        // Если Telegram верификация недоступна, возвращаемся к форме с капчей
        onClose();
      }
    } catch (error) {
      console.error('Error checking telegram:', error);
      // При ошибке также возвращаемся к форме с капчей
      onClose();
    }
  };

  const handleCodeSubmit = async () => {
    try {
      const response = await $api.get<ApiResponse>(
        showTelegramButton
          ? `/customers/checkTelegramCode/?phone=+${phone}&code=${code}`
          : `/customers/checkCode/?phone=+${phone}&code=${code}`
      );
      const data = response.data;

      if (data.status === 'OK') {
        if ('telegram_code_token' in data && data.telegram_code_token) {
          const telegramCodeToken = data.telegram_code_token;
          try {
            const utmSource = localStorage.getItem('utm_source');
            const utmTag = localStorage.getItem('utm_tag');

            const params = new URLSearchParams({
              phone: `+${phone}`,
              spam: 'false',
            });

            if (utmSource) params.set('utm_source', utmSource);
            if (utmTag) params.set('utm_tag', utmTag);

            const guestLoginResponse = await $api.get<GuestLoginResponse>(
              `/customers/get_by_phone/?${params.toString()}`,
              {
                headers: {
                  TelegramToken: telegramCodeToken,
                },
              }
            );
            
            if (guestLoginResponse.data.token && guestLoginResponse.data.download_urls) {
              const downloadUrls = guestLoginResponse.data.download_urls;
              console.log(downloadUrls)
              console.log('GUEST LOGIN после телеги пройден')
              localStorage.setItem('guestToken', guestLoginResponse.data.token);
              localStorage.setItem('phone', phone);
              localStorage.setItem('isExsistingUser', 'true');
              localStorage.setItem('authorization', 'true');

              dispatch(setGuestAuth(true));
              dispatch(setDownloadURLs(downloadUrls));
              history.push('/cards')
              return
            }
          } catch (error: any) {
            if (error.response?.status === 404 && error.response?.data?.token) {
              localStorage.setItem('guestToken', error.response.data.token);
              localStorage.setItem('phone', phone);
              /*localStorage.setItem('isExsistingUser', 'true');*/
              dispatch(setGuestAuth(true));
              history.push('/register');
            } else {
              console.error('Error in get_by_phone:', error);
              setShowError(true);
            }
          }
        }
      } else if (data.status === 'BAD') {
        setShowError(true);
        setCode('');
      }
    } catch (error) {
      console.error('Error checking code:', error);
      setShowError(true);
      setCode('');
    }
  };

  const goToTelegramBot = () => {
    if (telegramBotUrl) {
      window.open(telegramBotUrl, '_blank');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(/[^0-9]/g, '');
    setCode(newValue.substr(0, 4));
  };

  const handleAlternativeMethod = () => {
    onClose();
  };

  return (
    <>
      <div 
        className="popup-overlay" 
        style={{ backgroundColor: siteDesign.background_color1 }}
      >
        <div 
          className="popup"
          style={{ 
            backgroundColor: isMobileScreen 
              ? siteDesign.background_color1 
              : siteDesign.background_color2 
          }}
        >
          <a
            className="popup-back"
            onClick={onClose}
            style={{
              color: siteDesign.color_text,
              textShadow: siteDesign.text_shadow ? '1px 1px 2px rgba(0, 0, 0, 0.5)' : 'none'
            }}
          >
            ←
          </a>

          <p
            className="popup-text"
            style={{
              color: siteDesign.color_text,
              textShadow: siteDesign.text_shadow ? '1px 1px 2px rgba(0, 0, 0, 0.5)' : 'none'
            }}
          >
            Введите код
          </p>

          <input
            ref={codeInputRef}
            className="popup-input"
            value={code}
            onChange={handleInputChange}
            placeholder="_ _ _ _"
            maxLength={4}
            inputMode="numeric"
            pattern="[0-9]{4}"
            required
          />

          {showError && (
            <p className="popup-error">
              Неправильный код
            </p>
          )}

          <button
            className="popup-button"
            onClick={handleCodeSubmit}
            style={{
              backgroundColor: siteDesign.color_button,
              color: siteDesign.color_text_button
            }}
          >
            Отправить
          </button>

          {showTelegramButton && telegramBotUrl && (
            <>
              <button
                className="login-container__btnTG"
                onClick={goToTelegramBot}
              >
                Перейти в Telegram
              </button>
            </>
          )}
          {console.log('TelegramPopup - render button check - capcha_check value:', siteDesign?.capcha_check)}
          {siteDesign?.capcha_check === true && (
            <button
              className="popup-button popup-link"
              onClick={handleAlternativeMethod}
              style={{
                color: siteDesign.color_text,
                marginTop: '10px'
              }}
            >
              Другой способ
            </button>
          )}
        </div>
      </div>

      {isLoading && (
        <div className="loader-wrapper">
          {/* Add your loader component here */}
        </div>
      )}
    </>
  );
};

export default TelegramPopup; 
